import { IEventrFlight, IOptionsWithTypes } from "@eventr/common";

export const getAllPassengers = (flight: IEventrFlight) => {
  const all: IOptionsWithTypes[] = [];
  flight?.passengers_list?.forEach((p) => {
    all.push(...(p.users ?? []));
  });
  return all;
};
export const formatFlightNumber = (number: string) => {
  const flightNumber = number.replace(/\s+/g, "");
  return flightNumber === flightNumber.toUpperCase() ? flightNumber : flightNumber.toUpperCase();
};
